/**
 * Algolia Context Manager
 * Stores and retrieves search context (queryID, indexName)
 */

const AlgoliaContextManager = {
  MAX_TRACKING_ENTRIES: 100,
  MAX_AGE_MS: 7 * 24 * 60 * 60 * 1000,
  CLEANUP_COUNT: 10,

  storeSearchContext: function(queryID, indexName) {
    if (!queryID || !indexName) {
      return;
    }

    const context = {
      queryID: queryID,
      indexName: indexName,
      timestamp: Date.now()
    };

    try {
      sessionStorage.setItem('algolia_last_search', JSON.stringify(context));
    } catch (e) {
      console.warn('Failed to store search context:', e);
    }
  },

  getSearchContext: function() {
    try {
      const stored = sessionStorage.getItem('algolia_last_search');
      if (stored) {
        return JSON.parse(stored);
      }
    } catch (e) {
      console.warn('Failed to retrieve search context:', e);
    }
    return null;
  },

  storeProductContext: function(variantId, queryID, indexName, objectID) {
    if (!variantId) {
      return;
    }

    let tracking = {};
    try {
      const stored = sessionStorage.getItem('algolia_cart_tracking');
      if (stored) {
        tracking = JSON.parse(stored);
      }
    } catch (e) {
      console.warn('Failed to read cart tracking data:', e);
    }

    const now = Date.now();
    for (const [key, value] of Object.entries(tracking)) {
      if (value.timestamp && (now - value.timestamp > AlgoliaContextManager.MAX_AGE_MS)) {
        delete tracking[key];
      }
    }

    const keys = Object.keys(tracking);
    if (keys.length >= AlgoliaContextManager.MAX_TRACKING_ENTRIES) {
      const sortedKeys = keys.sort((a, b) => (tracking[a].timestamp || 0) - (tracking[b].timestamp || 0));
      for (let i = 0; i < AlgoliaContextManager.CLEANUP_COUNT; i++) {
        delete tracking[sortedKeys[i]];
      }
    }

    tracking[variantId] = {
      queryID: queryID,
      indexName: indexName,
      objectID: objectID,
      timestamp: Date.now()
    };

    try {
      sessionStorage.setItem('algolia_cart_tracking', JSON.stringify(tracking));
    } catch (e) {
      console.warn('Failed to store product context:', e);
    }
  },

  getProductContext: function(variantId) {
    try {
      const stored = sessionStorage.getItem('algolia_cart_tracking');
      if (stored) {
        const tracking = JSON.parse(stored);
        return tracking[variantId] || null;
      }
    } catch (e) {
      console.warn('Failed to retrieve product context:', e);
    }
    return null;
  },

  clearContext: function() {
    try {
      sessionStorage.removeItem('algolia_last_search');
      sessionStorage.removeItem('algolia_cart_tracking');
    } catch (e) {
      console.warn('Failed to clear context:', e);
    }
  }
};

if (typeof AlgoliaEvents !== 'undefined') {
  AlgoliaEvents.on(AlgoliaEvents.types.QUERY_RECEIVED, function(event) {
    const detail = event.detail;
    if (detail.queryID && detail.indexName) {
      AlgoliaContextManager.storeSearchContext(detail.queryID, detail.indexName);
    }
  });
}

window.AlgoliaContextManager = AlgoliaContextManager;
